import Constants from 'constants.js';
import Dispatcher from 'core/Dispatcher';
import SiteService from 'services/SiteService';
//Facade
import Facade from 'core/Facade';
// Actions
import AlertAction from 'actions/AlertAction';
// Locales
import translate from 'locales/i18n';

class SiteAction {
    getSites() {
        Dispatcher.dispatch({
            actionType: Constants.SITES_GET_START
        });

        SiteService.getSites().then(data => {
            Dispatcher.dispatch({
                actionType: Constants.SITES_GET_END,
                value: Facade.keysToCamel(data)
            });
        }, response => response && response.error && AlertAction.open('error', translate.i18n(response.error), 'top-right'));
    }

    addSite(options) {
        SiteService.addSite(options).then(site => {
            Dispatcher.dispatch({
                actionType: Constants.SITE_ADDED,
                value: Facade.keysToCamel(site)
            });

            AlertAction.open('success', translate.i18n('SUCCESS_ADD_SITE'), 'top-right');
        }, err => {
            AlertAction.open('error', translate.i18n('ERROR_ADD_SITE'), 'top-right');
            console.log(err);
        });
    }

    updateSite(options, id) {
        SiteService.updateSite(options, id).then(() => {
            Dispatcher.dispatch({
                actionType: Constants.SITE_UPDATED,
                value: {
                    options,
                    id
                }
            });

            AlertAction.open('success', translate.i18n('SUCCESS_UPDATE_SITE'), 'top-right');
        }, err => {
            AlertAction.open('error', translate.i18n('ERROR_UPDATE_SITE'), 'top-right');
            console.log(err);
        });
    }

    deleteSite(id) {
        SiteService.deleteSite(id).then(() => {
            Dispatcher.dispatch({
                actionType: Constants.SITE_DELETED,
                value: {
                    id
                }
            });
        }, err => {
            console.log(err);
        });
    }
}

export default new SiteAction();
